import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/karl/github.com/limbario/limbar/limbar-io/components/ui/console-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/karl/github.com/limbario/limbar/limbar-io/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/karl/github.com/limbario/limbar/limbar-io/node_modules/next/dist/client/image-component.js");
